import i18next from 'i18next';
import { Icon } from '@iconify/react';
import priceTagIcon from '@iconify/icons-mdi/tag-text';

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const pricePanelConfig = ({ pricePanel = true, robot = false } = {}) => ({
  title: i18next.t('pricePanel.title'), // Adicionado suporte para tradução
  path: '/products/price-panel',
  icon: getIcon(priceTagIcon),
  children: [
    pricePanel && { title: i18next.t('pricePanel.stores.title'), path: '/products/price-panel/stores' },
    pricePanel && { title: i18next.t('pricePanel.categories.title'), path: '/products/price-panel/categories' },
    pricePanel && { title: i18next.t('pricePanel.products.title'), path: '/products/price-panel/products' },
    pricePanel && { title: i18next.t('pricePanel.prices.title'), path: '/products/price-panel/prices' },
    robot && { title: 'Robot PP', path: '/products/price-panel/robot' },
  ].filter(Boolean),
});

export default pricePanelConfig;
